import { RequestDataDto } from "@app/core/dto/request-data.dto";
import { ActionCommand } from "../action-command-interface";
import { ActionCommandResponseDto } from "@app/core/dto/action-command-response.dto";
import { ModuleType } from "@app/core/enums/module-type.enum";
import { ActionPayloadDto, ActionRequestDto, UserRequestDto } from "@app/core/dto/abstract-action.dto";

export class SendOtpCommand implements ActionCommand {
  constructor() { }

  async execute(actionData: any, requestData: RequestDataDto): Promise<ActionCommandResponseDto> {
    if (requestData.module == ModuleType.USER) {
      const actionRequest: UserRequestDto = new UserRequestDto({
        action: actionData.type,
        payload: actionData.params,
      });

      requestData.finalData.userContext = actionRequest;
      requestData.module = ModuleType.USER;
    } else if (requestData.module == ModuleType.CHECKOUT) {
      const formattedAction: ActionRequestDto = new ActionRequestDto();
      formattedAction.action = actionData?.type;

      const payload = { ...actionData?.params };
      formattedAction.payload = new ActionPayloadDto(payload);
      requestData.updatedAction = { ...formattedAction };

      requestData.finalData.actionContext = requestData?.updatedAction;
      requestData.module = ModuleType.CHECKOUT;
    }
    return new ActionCommandResponseDto({
      shouldFetchData: true,
      requestData: requestData
    })
  }
}